<template>
  <div id="org">
    <headerTop title="组织机构管理" :getleft="showArrow" :showUser="showUser" />
    <el-row :span="10">
      <el-col :span="5"><navLeft :activeIndex="1" /></el-col>
      <el-col :span="20" class="system" style="background: #fff">
        <div>
          <div
            slot="header"
            class="clearfix"
            style="
              width: 100%;
              height: 50px;
              line-height: 50px;
              text-indent: 20px;
              border-bottom: 1px solid #ddd;
            "
          >
            <span style="font-size: 16px; font-weight: 600">组织机构管理</span>
          </div>
          <el-tree
            :data="data"
            node-key="id"
            :props="props"
            default-expand-all
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span class="addPosition">
                <el-button type="text" @click="() => add(data)">
                  <i class="el-icon-plus"></i>
                </el-button>
                <el-button type="text" @click="() => edit(data)">
                  <i class="el-icon-edit-outline"></i>
                </el-button>
                <el-button type="text" @click="() => remove(node, data)">
                  <i class="el-icon-delete"></i>
                </el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </el-col>
    </el-row>
    <div v-if="showadd">
      <el-dialog
        :title="infoTitle"
        :visible.sync="showadd"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        width="30%"
        class="dialog-class"
      >
        <el-form :rules="rules" ref="form" :model="form" label-width="130px">
          <el-form-item label="机构名称：" prop="orgName">
            <el-input v-model="form.orgName"></el-input>
          </el-form-item>
          <el-form-item
            label="同级或子级："
            prop="addType"
            v-if="infoTitle == '新增'"
          >
            <el-radio-group v-model="form.addType">
              <el-radio label="0" value="0">同级</el-radio>
              <el-radio label="1" value="1">子级</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否实体对象：" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio label="1" value="1">是</el-radio>
              <el-radio label="0" value="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="实体对象类型："
            v-if="form.type == '1'"
            prop="entityId"
          >
            <el-select v-model="form.entityId" @change="findfindEntitiesChange">
              <el-option
                v-for="item in entityList"
                :key="item.entityId"
                :label="item.name"
                :value="item.entityId"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="实体对象："
            v-if="form.type == '1'"
            prop="entityDetailId"
          >
            <el-select v-model="form.entityDetailId">
              <el-option
                v-for="item in secondList"
                :key="
                  item.adminRegionId ||
                  item.ownerId ||
                  item.stationId ||
                  item.roadId ||
                  item.serviceAreaId
                "
                :label="
                  item.name ||
                  item.ownerName ||
                  item.stationName ||
                  item.roadName ||
                  item.serviceAreaName
                "
                :value="
                  item.adminRegionId ||
                  item.ownerId ||
                  item.stationId ||
                  item.roadId ||
                  item.serviceAreaId
                "
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelSubmit">取 消</el-button>

          <el-button
            type="primary"
            @click="addSubmit('form')"
            v-if="infoTitle == '新增'"
            >确 定</el-button
          >
          <el-button
            type="primary"
            @click="editSubmit('form')"
            v-if="infoTitle == '编辑'"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import headerTop from "../components/headTop.vue";
import navLeft from "../components/navLeft.vue";
let id = 1000;
export default {
  data() {
    const data = [];
    return {
      entityList: [],
      secondList: [],
      props: {
        // disabled: "disabled",
        label: "name",
        children: "childs",
        isLeaf: "leaf",
      },
      infoTitle: "新增",
      form: {
        entityId: "",
        addType: "1",
        orgName: "",
        type: "1",
        entityDetailId: "",
      },
      addData: "",
      showadd: false,
      showArrow: true,
      data: JSON.parse(JSON.stringify(data)),
      data: JSON.parse(JSON.stringify(data)),
      showUser: true,
      //  orgName
      rules: {
        orgName: [
          { required: true, message: "机构名称不能为空", trigger: "blur" },
        ],
        addType: [
          { required: true, message: "请选择同级或子级", trigger: "blur" },
        ],
        entityId: [
          { required: true, message: "所属行政区域不能为空", trigger: "blur" },
        ],
        entityDetailId: [
          { required: true, message: "所属收费站不能为空", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getOrglist();
    this.getProvice();
    this.$forceUpdate();
  },
  methods: {
    findfindEntitiesChange() {
      let self = this;
      self.form.entityDetailId = "";
      self.findfindEntities();
    },
    findfindEntities() {
      let self = this;

      self.secondList = [];
      self.$http.post(
        self.api.findfindEntities + `?entityId=${self.form.entityId}`,
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        (res) => {
          if (res.code == "200") {
            self.secondList = res.body;
            self.$forceUpdate();
          } else {
          }
        },
        (error) => {}
      );
    },
    getProvice() {
      let self = this;
      self.$http.post(
        self.api.entities,
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        (res) => {
          if (res.code == "200") {
            self.entityList = res.body;
          } else {
          }
        },
        (error) => {}
      );
    },
    getOrglist() {
      let self = this;
      self.$http.post(
        self.api.allOrganizationJSON,
        {},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
        (res) => {
          if (res) {
            self.data = res.body;
          } else {
          }
        },
        (error) => {}
      );
    },
    cancelSubmit() {
      this.showadd = false;
      this.$refs.form.resetFields();
    },
    addSubmit(form) {
      let self = this;
      self.$refs[form].validate((valid) => {
        if (valid) {
          let params = {};
          params.organizeId = self.addData.organizeId;
          params.name = self.form.orgName;
          params.addType = self.form.addType;
          if (self.form.addType == 1) {
            params.parentOrgId = self.addData.organizeId;
          } else if (self.form.addType == 0) {
            params.parentOrgId = self.addData.parentId;
          } else {
            params.parentOrgId = "";
          }
          if (self.form.type == 1) {
            params.entityId = self.form.entityId;
            params.entityDetailId = self.form.entityDetailId;
          } else {
            params.entityId = "";
            params.entityDetailId = "";
          }
          params.type = self.form.type;

          self.$http.post(
            self.api.addOrganiza,
            params,
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
            (res) => {
              if (res.code == 200) {
                self.showadd = false;
                this.$refs.form.resetFields();
                self.getOrglist();
              } else {
                self.showadd = false;
                self.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            },
            (error) => {}
          );
        }
      });
    },
    add(data) {
      this.$forceUpdate();
      this.form = {
        entityId: "",
        addType: "1",
        orgName: "",
        type: "1",
        entityDetailId: "",
      };
      this.showadd = true;
      this.addData = data;
      this.infoTitle = "新增";
    },
    edit(data) {
      this.$forceUpdate();
      let self = this;
      self.form = {
        entityId: "",
        addType: "",
        orgName: "",
        type: "",
        entityDetailId: "",
      };
      self.infoTitle = "编辑";
      self.addData = data;
      console.log(data, "data");
      self.form.orgName = data.name;
      self.form.addType = String(data.addType);
      self.form.type = String(data.type);
      self.form.entityDetailId = String(data.entityDetailId);

      if (self.form.entityDetailId == "null") {
        self.form.entityDetailId = "";
      }
      self.form.entityId = data.entityId;
      self.findfindEntities();
      self.showadd = true;
    },
    editSubmit(form) {
      let self = this;
      self.$refs[form].validate((valid) => {
        if (valid) {
          self.showadd = false;
          console.log(self.addData, "addData");
          let params = {};
          params.organizeId = self.addData.organizeId;
          params.name = self.form.orgName;
          if (self.form.type == 1) {
            params.entityId = self.form.entityId;
            params.entityDetailId = parseInt(self.form.entityDetailId);
          } else {
            params.entityId = "";
            params.entityDetailId = "";
          }
          params.type = self.form.type;

          self.$http.post(
            self.api.updateOrganiza,
            params,
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
            (res) => {
              if (res) {
                self.getOrglist();
              } else {
              }
            },
            (error) => {}
          );
        }
      });

      //   const newChild = { id: id++, label: this.form.orgName, children: [] };
      //   if (!this.addData.children) {
      //     this.$set(this.addData, "children", []);
      //   }
      //   this.addData.children.push(newChild);
    },
    remove(node, data) {
      let self = this;
      self
        .$confirm("此操作将永久删除该机构, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          self.$http.post(
            self.api.delOrganiza +
              `?organizeId=${data.organizeId}&&parentOrganizateId=${data.parentId}`,
            {},
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
            (res) => {
              if (res) {
                self.getOrglist();
                self.$message.success("成功删除！");
              } else {
              }
            },
            (error) => {}
          );
        })
        .catch(() => {});
    },

    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.append(data)}
            >
              Append
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              Delete
            </el-button>
          </span>
        </span>
      );
    },
  },
  components: { headerTop, navLeft },
};
</script>
<style>
#org .savebtn {
  display: block;
  margin: 0 auto;
  margin-top: 400px;
  width: 50%;
  text-align: center;
}
#org .savebtn button {
  width: 100%;
}
#org .el-tree-node__content {
  display: block;
  margin: 0 auto;
  margin-bottom: 15px;
}
#org .system {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: fixed;
  left: 320px;
  bottom: 0;
  top: 84px;
  right: 20px;
  height: 100%;
  overflow-y: auto;
}
#org .system .el-tree {
  width: 30%;
  margin-top: 20px;
  margin-left: 20px;
}
#org .addPosition {
  position: absolute;
  right: 0;
}
#org .el-select {
  width: 100%;
  margin-right: 15px;
}
#org .addPosition i {
  font-size: 16px;
}
.custom-tree-node {
  font-size: 18px;
}
.addPosition i {
  font-size: 18px;
}
#org .dialog-class .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
#org .dialog-class .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
#org .dialog-class .el-dialog__header .el-dialog__title {
  font-weight: 600;
  color: #606266;
}
#org .el-button--mini {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/view/orgnization.vue